<template>
  <button
    v-if="mobileTestbedActive"
    class="mobile-card-handle"
    aria-label="Change card height"
    @click="emit('click')"
  >
    <span />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { isMobileTestbedActive } from '@/lib/prototyping-flags'
const emit = defineEmits<{
  (e: 'click'): void
}>()
const mobileTestbedActive = computed(() => isMobileTestbedActive())
</script>

<style scoped lang="scss">
@use '@/styles/system/_breakpoints.scss';
@use '@/styles/_layer-map.scss';
.mobile-card-handle {
  display: none;
  pointer-events: none;
  appearance: none;
  @include breakpoints.app-prototyping {
    display: block;
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    background: none;
    padding: 12px;
    cursor: pointer;
    pointer-events: initial;
    z-index: layer-map.$z-index-level-controls;
  }
  span {
    display: block;
    width: 100px;
    height: 12px;
    background-color: var(--ys-color-surface-secondary);
    border-radius: 10px;
  }
}
</style>
